'use strict';

import ViewModel from './viewModel.js';
import { isLittleEndian } from './utils.js';
import Model from './model.js';

if (typeof WebAssembly != 'object') {
  throw new Error('no native wasm support detected');
}

if (!isLittleEndian()) {
  throw new Error('Runtime error: expected the system to be little-endian! (Run with -sSUPPORT_BIG_ENDIAN to bypass)');
}

async function initialise({ name, colourOverrides, onPresetAdded, onUndoRedoEnabled, onInitialise, onMove, onCompleted }) {
  const viewModel = new ViewModel({ name, colourOverrides, onPresetAdded, onUndoRedoEnabled, onInitialise, onMove, onCompleted });
  const model = await Model.create(viewModel);

  viewModel.init(model);
  return model.init() ? viewModel : null;
}

export default { initialise };
